/** @namespace System */
NS("System");
/**
 * Promises collection
 *
 * @class
 */
System.Promises = Class( /** @lends System.Promises.prototype */ {
    promises_: {},
    /**
     * @param {string} name
     * @param {*} value
     * @param {function} [onCancel = function() {}]
     * @returns {Promise}
     */
    addPromise(name, value, onCancel = _.noop) {
        this.cancelPromise(name);
        this.promises_[name] = Promise.resolve(value).finally(() => delete this.promises_[name]);
        this.promises_[name].onCancel__ = onCancel;

        return this.promises_[name];
    },
    /**
     * @param {string} name
     */
    cancelPromise(name) {
        const promise = this.promises_[name];

        if (promise) {
            promise.cancel();
            delete this.promises_[name];
            Util.call(promise.onCancel__);
        }
    },
    /**
     * Cancels all promises
     */
    cancelAllPromises() {
        _.forEach(_.keys(this.promises_), this.cancelPromise.bind(this));
    }
});
